import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { CtaButton } from './CtaButton';
function RevealBlock({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const ref = useScrollReveal<HTMLDivElement>();
  return <div ref={ref} className={`opacity-0 translate-y-10 transition-all duration-700 ease-out ${className}`} data-id="element-129">
      {children}
    </div>;
}
export function OfferSection() {
  return <section id="oferta" className="py-20 px-5 relative overflow-hidden" style={{
    background: 'linear-gradient(160deg, #0E1F1A 0%, #2B4A42 100%)'
  }} data-id="element-130">
      {/* Decorative circle */}
      <div className="absolute -bottom-[100px] -left-[100px] w-[400px] h-[400px] rounded-full" style={{
      background: 'radial-gradient(circle, rgba(201, 168, 76, 0.08), transparent 70%)'
    }} data-id="element-131" />

      <div className="max-w-[760px] mx-auto" data-id="element-132">
        <RevealBlock data-id="element-133">
          <div className="border rounded-card-lg py-12 px-10 max-w-[640px] mx-auto relative z-10 text-center md:py-12 md:px-10" style={{
          background: 'rgba(255,255,255,0.05)',
          backdropFilter: 'blur(20px)',
          borderColor: 'rgba(201, 168, 76, 0.25)'
        }} data-id="element-134">
            {/* Badge */}
            <span className="inline-block bg-oro text-negro-carbon text-[0.75rem] font-bold py-1.5 px-4 rounded-full uppercase tracking-[1px] mb-6" data-id="element-135">
              ⚡ Oferta de Lanzamiento
            </span>

            <h2 className="font-display text-white mb-3 leading-[1.3]" style={{
            fontSize: 'clamp(1.5rem, 4vw, 2rem)'
          }} data-id="element-136">
              La Hormona Que Está Engordando
              <br data-id="element-137" />
              Tu Abdomen Después de los 45
            </h2>

            <p className="text-white/75 text-[0.97rem] mb-9 leading-[1.7]" data-id="element-138">
              El Protocolo de Rescate Metabólico de 7 días para mujeres que ya
              lo han intentado todo y quieren una solución real, simple y basada
              en ciencia.
            </p>

            {/* Includes list */}
            <ul className="list-none mb-9 text-left" data-id="element-139">
              <OfferItem data-id="element-140">
                <strong data-id="element-141">La Prueba del Espejo:</strong> Identifica tu tipo de
                grasa hormonal en 30 segundos.
              </OfferItem>
              <OfferItem data-id="element-142">
                <strong data-id="element-143">El Interruptor de las 8 AM:</strong> La rutina matutina
                anti-cortisol para quemar grasa desde el despertar.
              </OfferItem>
              <OfferItem data-id="element-144">
                <strong data-id="element-145">La Técnica del Muro de Glucosa:</strong> Come lo que
                amas sin disparar la insulina.
              </OfferItem>
              <OfferItem data-id="element-146">
                <strong data-id="element-147">El Suplemento de $10:</strong> El mineral que elimina
                antojos nocturnos y activa el sueño reparador.
              </OfferItem>
              <OfferItem data-id="element-148">
                <strong data-id="element-149">El Movimiento de Drenaje:</strong> 10 minutos que
                reemplazan 1 hora de cardio intenso.
              </OfferItem>
              <OfferItem isLast data-id="element-150">
                <strong data-id="element-151">El Protocolo Nocturno:</strong> Cómo quemar grasa
                mientras duermes en 3 pasos simples.
              </OfferItem>
            </ul>

            {/* Price display */}
            <div className="my-8 p-6 rounded-card border" style={{
            background: 'rgba(255,255,255,0.06)',
            borderColor: 'rgba(201, 168, 76, 0.2)'
          }} data-id="element-152">
              <div className="text-white/40 line-through text-base mb-1" data-id="element-153">
                Valor real del protocolo: $47.00 USD
              </div>
              <div className="font-display text-[3.5rem] font-black text-oro leading-none mb-1.5" data-id="element-154">
                $6.36
              </div>
              <div className="text-white/60 text-[0.82rem]" data-id="element-155">
                Precio de validación · Acceso inmediato en PDF · Descarga desde
                cualquier dispositivo
              </div>
            </div>

            {/* CTA */}
            <div className="flex justify-center" data-id="element-156">
              <CtaButton href="https://simplementemejor.com/cart/51819834016024:1" ariaLabel="Comprar el protocolo por $6.36" data-id="element-157">
                Sí, Quiero Apagar Mi Cortisol Ahora
              </CtaButton>
            </div>

            {/* Security */}
            <div className="flex items-center justify-center gap-5 mt-5 flex-wrap" data-id="element-158">
              <span className="flex items-center gap-1.5 text-white/60 text-[0.78rem] font-medium" data-id="element-159">
                <span className="text-[0.9rem]" data-id="element-160">🔒</span> Pago 100% Seguro
              </span>
              <span className="flex items-center gap-1.5 text-white/60 text-[0.78rem] font-medium" data-id="element-161">
                <span className="text-[0.9rem]" data-id="element-162">📱</span> Acceso Inmediato
              </span>
              <span className="flex items-center gap-1.5 text-white/60 text-[0.78rem] font-medium" data-id="element-163">
                <span className="text-[0.9rem]" data-id="element-164">↩️</span> Garantía 7 días
              </span>
            </div>
          </div>
        </RevealBlock>
      </div>
    </section>;
}
function OfferItem({
  children,
  isLast = false
}: {
  children: React.ReactNode;
  isLast?: boolean;
}) {
  return <li className={`flex items-start gap-3 py-3 text-white/[0.88] text-[0.93rem] ${isLast ? '' : 'border-b border-white/[0.08]'}`} data-id="element-165">
      <span className="w-6 h-6 rounded-full flex items-center justify-center text-[0.75rem] font-bold flex-shrink-0 mt-px" style={{
      background: 'rgba(201, 168, 76, 0.2)',
      color: '#C9A84C'
    }} data-id="element-166">
        ✓
      </span>
      <span data-id="element-167">{children}</span>
    </li>;
}